import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { CommonModule, DOCUMENT } from '@angular/common'
import { Store } from '@ngrx/store'
import {
	Client,
	ClientActions,
	getClient,
	getSelectOrder,
	OrderHistory,
	VenueDetail,
} from '@monorepo-channels/channels/domain'
import { combineLatest, map, take, timer } from 'rxjs'
import { MatBottomSheet } from '@angular/material/bottom-sheet'
import { CancelOrderComponent } from '../../simple-bottom-sheets/cancel-order.component'
import {
	CelebrationsRibbonComponent,
	FooterButtonsComponent,
	SwiperUiComponent,
} from '@monorepo-channels/components/ui-pm'
import { Router, RouterOutlet } from '@angular/router'
import {
	CapitalizeFirstPipe,
	isMobile,
	openResponsiveComponent,
} from '@monorepo-channels/shared/util-helpers'
import { BenefitsUiComponent } from '@monorepo-channels/components/ui-pm'
import { BreadcrumbsComponent } from '../../breadcrumbs/breadcrumbs.component'
import { RegisterOrLoginComponent } from '../../simple-bottom-sheets/register-or-login.component'
import { MatDialog } from '@angular/material/dialog'

@Component({
	selector: 'feature-pm-order-details',
	standalone: true,
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		SwiperUiComponent,
		CapitalizeFirstPipe,
		FooterButtonsComponent,
		CelebrationsRibbonComponent,
		BenefitsUiComponent,
		BreadcrumbsComponent,
		RouterOutlet,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA], // why? because of the custom element <swiper-element>
	templateUrl: './order-details.component.html',
	styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
	isMobile = isMobile()
	expandedBasketIds = new Set<string>()
	private store = inject(Store)
	private router = inject(Router)
	private selectedOrder$ = this.store.select(getSelectOrder)
	private client$ = this.store.select(getClient)
	public bottomSheet = inject(MatBottomSheet)
	public dialog = inject(MatDialog)
	private document = inject(DOCUMENT)
	public copied = signal(false)

	public vm$ = combineLatest([this.selectedOrder$, this.client$]).pipe(
		map(([order, client]) => ({ order, client }))
	)

	ngOnInit(): void {
		this.selectedOrder$.pipe(take(1)).subscribe(order => {
			if (!order) {
				this.goBack()
			}
		})
	}

	share(venueDetail: VenueDetail) {
		const url = `${this.document.location.href}?shared=true`

		if (navigator.share) {
			navigator
				.share({
					title: venueDetail.name,
					text: 'Confira esse restaurante no Bradesco Programa Menu',
					url: url,
				})
				.catch(error => console.log('Sharing failed', error))
		} else {
			navigator.clipboard.writeText(url).then(() => {
				this.showCopiedNotification()
			})
		}
	}
	showCopiedNotification() {
		this.copied.set(true)
		timer(2000)
			.pipe(take(1))
			.subscribe(() => {
				this.copied.set(false)
			})
	}

	toggleFavorite(venueId: string, client: Client | null) {
		if (!client) {
			openResponsiveComponent({
				component: RegisterOrLoginComponent,
				isMobile: this.isMobile,
				bottomSheet: this.bottomSheet,
				dialog: this.dialog,
			})
			return
		}
		this.store.dispatch(ClientActions.toggleFavorite({ venueId }))
	}

	goBack() {
		this.router.navigate(['/reservas-e-checkins'])
	}

	cancelOrder(order: OrderHistory | null) {
		if (!order) return
		openResponsiveComponent({
			component: CancelOrderComponent,
			config: { data: order },
			isMobile: this.isMobile,
			bottomSheet: this.bottomSheet,
			dialog: this.dialog,
		})
	}

	toggleDescription(event: MouseEvent, basketId: string) {
		event.stopPropagation()
		event.preventDefault()
		if (this.expandedBasketIds.has(basketId)) {
			this.expandedBasketIds.delete(basketId)
		} else {
			this.expandedBasketIds.add(basketId)
		}
	}
}
